import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import Select from 'react-select';

import Modal from '../../common/Modal';
import Render from '../../common/Render';
import * as API from '../../core/api';
import { updateProjects } from '../../user/duck';

const formatGroupLabel = (data) => (
  <div className="u-display-flex u-justify-content-between u-align-items-center">
    <span className="c-select__group-title">{data.label}</span>
    <span className="c-select__group-counter">{data.options.length}</span>
  </div>
);

class AddFromExistingProjects extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isModalOpen: false,
      selectedProjectId: 'NONE',
      selectedProjectName: '',
    };
  }

  handleProjectAdd = () => {
    const { updateProjects, onSuccess } = this.props;
    const { selectedProjectId } = this.state;

    API.post('users/me/projects', { project: selectedProjectId })
      // Refresh the user
      .then((user) => updateProjects(user.projects))
      .then(() => this.handleModalClose())
      .then(() => onSuccess && onSuccess());
  };

  getMultipleProjectTypeLabel = (type) => {
    const { t } = this.props;

    switch (type) {
      case 'SIDE':
        return t('project.types.side');
      default:
      case 'DEFAULT':
        return t('project.types.default');
    }
  };

  renderItems = () => {
    const {
      areMultipleProjectTypesEnabled,
      projects,
      projectsType,
    } = this.props;

    if (areMultipleProjectTypesEnabled) {
      return projectsType.map((currentType) => ({
        label: this.getMultipleProjectTypeLabel(currentType),
        options: projects
          .filter(({ type }) => type === currentType)
          .map(({ _id, name }) => ({
            value: _id,
            label: name,
          })),
      }));
    }

    return this.props.projects.map(({ _id, name }) => ({
      value: _id,
      label: name,
    }));
  };

  handleModalOpen = () => {
    this.setState({ isModalOpen: true });
  };

  handleModalClose = () => {
    this.setState({ isModalOpen: false });
    this.setState({
      selectedProjectId: 'NONE',
      selectedProjectName: '',
    });
  };

  handleSelectChange = (item) => {
    // The change event fires on focus out
    // or on pressing backspace in the search too,
    // which causes a popup to appear. Howeve, in these cases, simply do nothing.
    // Credits to @GoranStoyanov for finding this one.
    if (_.isEmpty(item)) {
      return;
    }

    this.handleModalOpen();
    this.setState({
      selectedProjectId: item.value,
      selectedProjectName: item.label,
    });
  };

  renderAfterLoading = () => {
    const { t } = this.props;
    const { isModalOpen, selectedProjectId, selectedProjectName } = this.state;

    return (
      <React.Fragment>
        <Select
          noOptionsMessage={() => t('search.noProjectsFound')}
          defaultValue="NONE"
          classNamePrefix="c-select"
          className="u-margin-bottom u-z-index-on-top"
          value={selectedProjectId}
          onChange={this.handleSelectChange}
          options={this.renderItems()}
          placeholder={t('general.chooseProject')}
          formatGroupLabel={formatGroupLabel}
          isSearchable
        />
        <Modal
          isOpen={isModalOpen}
          onRequestClose={this.handleModalClose}
          title={t('project.join.title')}
        >
          <p className="u-weight-light">
            {t('project.join.note', { name: selectedProjectName })}
          </p>

          <div className="u-text-center u-margin-bottom u-margin-top-huge">
            <div className="u-display-flex u-justify-content-around u-flex-wrap u-padding-horizontal-huge">
              <button
                className="c-btn c-btn-outline u-margin-vertical-micro"
                onClick={this.handleModalClose}
              >
                {t('general.oopsCancel')}
              </button>
              <button
                className="c-btn c-btn-outline c-btn-outline--primary u-margin-vertical-micro"
                onClick={this.handleProjectAdd}
              >
                {t('project.join.confirmBtn')}
              </button>
            </div>
          </div>
        </Modal>
      </React.Fragment>
    );
  };

  render() {
    const { isLoading, error } = this.props;

    return (
      <Render
        isLoading={isLoading}
        error={error}
        render={this.renderAfterLoading}
      />
    );
  }
}

const mapStateToProps = (store, { projects, user, projectsType }) => {
  // Mechanism to not display projects user already works actively on
  const userActiveProjectsIds =
    user.data &&
    user.data.projects
      .filter(({ status }) => status === 'ACTIVE')
      .map((p) => p.project._id);

  const areMultipleProjectTypesEnabled = typeof projectsType !== 'string';

  return {
    projects:
      userActiveProjectsIds &&
      projects.data &&
      projects.data
        .filter(({ type }) => {
          // projectsType can be either one (string) or an array of types
          if (typeof projectsType === 'string') {
            return type === projectsType;
          } else {
            return projectsType.includes(type);
          }
        })
        .filter(({ _id }) => !userActiveProjectsIds.includes(_id)),
    areMultipleProjectTypesEnabled,
    user: user.data,
    isLoading:
      projects.isLoading === null || projects.isLoading || user.isLoading,
    error: projects.error || user.error,
  };
};

const mapDispatchToProps = { updateProjects };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate()(AddFromExistingProjects));



// WEBPACK FOOTER //
// ./src/user/join-projects/Join.js